const PHONE_REGEX = /^(?:886|0)9[0-9]{8}$/;

customElements.define('custom-edit-account-form', class extends HTMLElement {
  submitData = {};
  constructor() {
    super();
    this.validateMessages = JSON.parse(this.querySelector('[data-validate]').getAttribute('data-validate') ?? "{}")
    this.email = this.querySelector("#EditAccountEmail");
    this.subscribeEmail = this.querySelector("#EditAccountSubscribeEmail");
    this.subscribeSMS = this.querySelector("#EditAccountSubscribeSMS");
    this.cstmIntgSeq = this.querySelector("#EditAccountCstmIntgSeq");

    this.querySelector('input[name="subscribe_email"]').addEventListener('change', (e) => {
      localStorage.setItem('emailYN', e.target.checked ? 'Y' : 'N');
    });

    const mobileNoInput = this.querySelector('#EditAccountPhoneNumber');

    mobileNoInput.addEventListener('input', (e) => {
      e.target.value = e.target.value.replace(/[^0-9]/g, '');
    });

    mobileNoInput.addEventListener('keypress', (e) => {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    });

    const referrerMobileNoInput = this.querySelector('#EditAccountReferrerMobileNo');

    // the field is rendered only when the customer has no referrer yet
    referrerMobileNoInput?.addEventListener('input', (e) => {
      e.target.value = e.target.value.replace(/[^0-9]/g, '');
    });

    referrerMobileNoInput?.addEventListener('keypress', (e) => {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    });

    mobileNoInput.addEventListener('change', () => {
      const verificationCodeWrapper = this.querySelector("#FormField-editAccountOTPVerification")
      verificationCodeWrapper.querySelector('input').setAttribute('readonly', '');
      verificationCodeWrapper.querySelector('input').value = '';
      verificationCodeWrapper.querySelector('button').setAttribute('disabled', '');
    })


    this.querySelector(`form .btn-wrapper`)?.addEventListener('click', (e) => {
      const formValidate = this.handleProcessForm();
      if (formValidate.type !== "success") return;
      const formData = new FormData(this.querySelector('form'));
      const obj = {};
      for (const [name, value] of formData) {
        obj[name] = value;
      }

      const inputBirthDay = obj["birthday-day"] && obj["birthday-month"] && obj["birthday-year"]
        ? `${obj["birthday-year"]}/${obj["birthday-month"]}/${obj["birthday-day"]}`
        : "";

      this.submitData.emailYN = obj.subscribe_email === 'email' ? 'Y' : 'N';
      this.submitData.smsYN = obj.subscribe_sms === 'sms' ? 'Y' : 'N';
      this.submitData.sex = obj.gender
        ? obj.gender === "M" || obj.gender === 'Nam' || obj.gender === "Male"
          ? 'M' : 'F'
        : "";
      this.submitData.uid = obj.uid;
      this.submitData.firstName = obj.first_name;
      this.submitData.lastName = obj.last_name;
      this.submitData.mobileNo = obj.mobileNo;
      this.submitData.cstmIntgSeq = obj.cstmIntgSeq ?? "";
      this.submitData.email = obj.email;

      const toMetafield = ({ namespace, key }, value) => ({ namespace, key, value });
      const { GENDER, BIRTHDAY, REF_MOBILE_NO } = window.METAFIELDS;
      const metafields = [toMetafield(GENDER, this.submitData.sex)];

      const birthDayStr = obj.birthDay || inputBirthDay;
      if (birthDayStr) {
        const birthDayArr = birthDayStr.split('/').map(item => item.padStart(2, '0'));
        this.submitData.birthDay = birthDayArr.join("");
        metafields.push(toMetafield(BIRTHDAY, birthDayArr.join("-")));
      }

      const referrerMobileNo = obj.referrerMobileNo?.trim();
      if (referrerMobileNo) {
        metafields.push(toMetafield(REF_MOBILE_NO, referrerMobileNo));
      }

      this.submitData.metafields = metafields;
      this.handleSubmitForm(this.submitData)
    })

    this.handleFetchInitData();
    this.handleSendOTP();
    this.handleVerifyOTP();
  }

  handleSendOTP() {
    this.querySelector('#EditAccountForm-sendOTPBtn').addEventListener('click', async (e) => {
      const phoneFieldWrapper = this.querySelector('#FormField-editAccountPhoneNumber');
      let phoneValue = phoneFieldWrapper.querySelector('input').value.trim();
      const errorPhoneField = phoneFieldWrapper.querySelector('.form-field__text--error');
      const successMessage = phoneFieldWrapper.querySelector('.form-field__text--success');

      if (!phoneValue) {
        errorPhoneField.classList.remove('hidden');
        successMessage.classList.add('hidden');
      } else if (!PHONE_REGEX.test(phoneValue)) {
        errorPhoneField.innerHTML = this.validateMessages.phoneInvalid || this.validateMessages.phoneMinlength;
        errorPhoneField.classList.remove('hidden');
        successMessage.classList.add('hidden');
      } else {
        const sendOTPSpinner = phoneFieldWrapper.querySelector('.loading__spinner');
        sendOTPSpinner.classList.remove('hidden');

        const customerExistedRes = await this.handleCheckCustomerExisted({
          mobileNo: phoneValue.replace(window.phonePrefix, '0'),
          email: this.querySelector('#EditAccountEmail').value.trim(),
        })

        const isShopifyCustomerPhoneExisted = customerExistedRes.data.phone; // from Shopify

        if (isShopifyCustomerPhoneExisted) {
          errorPhoneField.innerText = this.validateMessages.phoneExisted;
          errorPhoneField.classList.remove('hidden');
          sendOTPSpinner.classList.add('hidden');

          successMessage.classList.add('hidden');
          return;
        }

        this.handleSendOTPRequest(phoneValue)
          .then(res => {
            if (res?.smsStatus === 'MESSAGE_SENT') {
              successMessage.classList.remove('hidden');
              errorPhoneField.classList.add('hidden');
              const verificationCodeWrapper = this.querySelector("#FormField-editAccountOTPVerification")
              verificationCodeWrapper.querySelector('input').removeAttribute('readonly');
              verificationCodeWrapper.querySelector('input').focus();
              verificationCodeWrapper.querySelector('button').removeAttribute('disabled');
              const pinIdInput = this.querySelector('[name="pinId"]')
              if (pinIdInput) {
                pinIdInput.value = res.pinId
              } else {
                const form = this.querySelector('form');
                const pinId = document.createElement('input');
                pinId.type = 'hidden';
                pinId.name = 'pinId';
                pinId.value = res.pinId;
                form.appendChild(pinId);
              }
            } else {
              successMessage.classList.add('hidden');
              errorPhoneField.classList.remove('hidden');
              errorPhoneField.innerText = this.validateMessages.codeSentFailed;
            }

            const sendOTPButton = phoneFieldWrapper.querySelector('button');
            const sendOTPButtonText = sendOTPButton.querySelector('.button__text');
            let timeLeft = 60;

            sendOTPButton.disabled = true;
            sendOTPButtonText.innerText = `${this.validateMessages.resend} (${timeLeft})`;
            const timerInterval = setInterval(() => {
              timeLeft--;

              if (timeLeft <= 0) {
                clearInterval(timerInterval);
                sendOTPButton.disabled = false;
                sendOTPButtonText.innerText = this.validateMessages.resend;
              } else {
                sendOTPButtonText.innerText = `${this.validateMessages.resend} (${timeLeft})`;
              }
            }, 1000);
          })
          .catch(() => {
            this.querySelector('#EditAccountForm-sendOTPBtn').removeAttribute('disabled');

            successMessage.classList.add('hidden');
            errorPhoneField.classList.remove('hidden');
            errorPhoneField.innerText = this.validateMessages.codeSentFailed;
          })
          .finally(() => {
            sendOTPSpinner.classList.add('hidden');
          })
      }
    })
  }

  async handleSendOTPRequest(mobileNo) {
    const url = window.middlewareUrls.sendOTP + (window.isOTPTest ? '?mockInfobip=true' : '');
    try {
      // 입력은 숫자만 받으므로: 0으로 시작하면 0 제거 후 +886 추가, 886으로 시작하면 +886으로 변경
      let phone;
      if (mobileNo.startsWith('886')) {
        phone = window.phonePrefix + mobileNo.substring(3); // 886 제거 후 +886 추가
      } else if (mobileNo.startsWith('0')) {
        phone = window.phonePrefix + mobileNo.substring(1); // 0 제거 후 +886 추가
      } else {
        phone = window.phonePrefix + mobileNo; // 그 외의 경우 +886 추가
      }
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ phoneNumber: phone })
      });
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const resJson = await response.json();
      return resJson;
    } catch (error) {
      console.error(error.message);
    }
  }

  handleVerifyOTP() {
    this.querySelector('#FormField-editAccountOTPVerification button').addEventListener('click', () => {
      const fieldWrapper = this.querySelector('#FormField-editAccountOTPVerification');
      const spinner = fieldWrapper.querySelector('.loading__spinner');
      spinner.classList.remove('hidden');
      fieldWrapper.querySelector("input").setAttribute('readonly', '');
      fieldWrapper.querySelector("button").setAttribute('disabled', '');
      const pin = fieldWrapper.querySelector('input').value.trim();
      const pinId = this.querySelector('form input[name="pinId"]').value;

      const successMessage = fieldWrapper.querySelector('.form-field__text--success');
      const errorMessage = fieldWrapper.querySelector('.form-field__text--error');

      this.handleVerifyOTPRequest(pin, pinId)
        .then(async (res) => {
          if (res?.verified) {
            successMessage.classList.remove('hidden');
            errorMessage.classList.add('hidden');
            return true;
          } else {
            fieldWrapper.querySelector("button").removeAttribute('disabled');
            fieldWrapper.querySelector("input").removeAttribute('readonly');
            successMessage.classList.add('hidden');
            errorMessage.classList.remove('hidden');
            errorMessage.innerText = this.validateMessages.codeVerifiedFailed;
            return false
          }
        })
        .then(async (isVerified) => {
          if (!isVerified) return;
          const resFetchCustomer = await this.handleCheckCustomerExisted({
            mobileNo: this.querySelector('#EditAccountPhoneNumber').value.trim(),
            email: this.querySelector('#EditAccountEmail').value.trim(),
          })

          if (!resFetchCustomer?.data || !Object.keys(resFetchCustomer.data).length) {
            ["CstmIntgSeq", "Gender"].forEach(field => {
              const fieldId = "#EditAccount" + field;
              this.querySelector(fieldId).setAttribute('disabled', '');
              this.querySelector(fieldId).value = "";
            });
            return;
          }

          const isPhoneExisted = resFetchCustomer.data.phone; // from Shopify
          const phoneFieldWrapper = this.querySelector('#EditAccountPhoneNumber');

          if (isPhoneExisted) {
            const errorPhoneField = phoneFieldWrapper.querySelector('.form-field__text--error');
            errorPhoneField.innerText = this.validateMessages.phoneExisted;
            errorPhoneField?.classList?.remove('hidden');
          }

          [
            { formFieldName: "Email", dataFieldName: "email" },
            { formFieldName: "FirstName", dataFieldName: "firstName" },
            { formFieldName: "LastName", dataFieldName: "lastName" },
            { formFieldName: "CstmIntgSeq", dataFieldName: "cstmIntgSeq" },
            { formFieldName: "Gender", dataFieldName: "sex" },
            { formFieldName: "Birthday", dataFieldName: "birthDay" }
          ].forEach(field => {
            const initValue = resFetchCustomer.data[field.dataFieldName] || '';
            if (initValue) {
              if (field.formFieldName === 'birthday') {
                this.handlePopulateBirthDayField(initValue);
                return;
              }
              const fieldId = "#EditAccount" + field.formFieldName;
              this.querySelector(fieldId).removeAttribute('disabled');
              this.querySelector(fieldId).value = initValue;
            }
          });

          ["Email", "SMS"].forEach(fieldName => {
            const fieldId = "#EditAccountSubscribe" + fieldName;
            this.querySelector(fieldId).checked = resFetchCustomer.data[fieldName] === "Y" || false;
          });
        })
        .catch((e) => {
          console.error(e.message);
          fieldWrapper.querySelector("button").removeAttribute('disabled');
          fieldWrapper.querySelector("input").removeAttribute('readonly');
          successMessage.classList.add('hidden');
          errorMessage.classList.remove('hidden');
          errorMessage.innerText = this.validateMessages.codeVerifiedFailed;
        })
        .finally(() => {
          spinner.classList.add('hidden');
        })
    })
  }

  async handleVerifyOTPRequest(pin, pinId) {
    const url = window.middlewareUrls.verifyOTP + (window.isOTPTest ? '?mockInfobip=true' : '');
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ pin, pinId })
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const resJson = await response.json();
      return resJson;
    } catch (error) {
      console.error(error.message);
    }
  }

  handlePopulateBirthDayField(value) {
    if (!value) return;
    const birthdayYearField = this.querySelector('#EditAccountDateOfBirthYear');
    const birthdayMonthField = this.querySelector('#EditAccountDateOfBirthMonth');
    const birthdayDayField = this.querySelector('#EditAccountDateOfBirthDay');
    const year = value.slice(0, 4);
    const month = value.slice(4, 6)
    const day = value.slice(6, 8);
    birthdayYearField.value = year;
    birthdayMonthField.value = month;
    birthdayDayField.value = day;
  }

  async handleCheckCustomerExisted({ email = "", mobileNo = "" }) {
    const url = window.middlewareUrls.customerCheck;
    let mobileNoWithPhonePrefix = mobileNo
    const phonePrefixWithoutPlus = window.phonePrefix.replace('+', '');

    if ((/^0/.test(mobileNo))) {
      mobileNoWithPhonePrefix = `${window.phonePrefix}${mobileNo.slice(1)}`;
    } else if (mobileNo.startsWith(phonePrefixWithoutPlus)) {
      mobileNoWithPhonePrefix = `+${mobileNo}`;
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, mobileNo: mobileNoWithPhonePrefix })
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const resJson = await response.json();
      return resJson;
    } catch (error) {
      console.error(error.message);
    }
  }

  handleProcessForm() {
    let type = 'success';
    const requiredFields = this.querySelectorAll('[required]');
    requiredFields.forEach(field => {
      const ancestorNode = field.closest('[id^="FormField-"]');
      const errorField = ancestorNode.querySelector('.form-field__text--error');
      if (
        (field.type === "radio" && this.querySelectorAll(`input[name="${field.name}"]:checked`).length === 0) ||
        (field.type !== "radio" && !field.value.trim())
      ) {
        errorField?.classList?.remove('hidden');
        type = 'error';
      } else {
        errorField?.classList?.add('hidden');
      }
    })
    const referrerField = this.querySelector('#EditAccountReferrerMobileNo');
    if (referrerField) {
      const referrerErrorField = referrerField.closest('[id^="FormField-"]').querySelector('.form-field__text--error');
      const referrerValue = referrerField.value.trim();
      const normalizePhone = (phone) => phone.replace(/\D/g, '').replace(/^886/, '0');
      const ownPhoneValue = normalizePhone(this.querySelector('#EditAccountPhoneNumber').value);
      if (referrerValue && !PHONE_REGEX.test(referrerValue)) {
        referrerErrorField.innerText = this.validateMessages.phoneInvalid;
        referrerErrorField.classList.remove('hidden');
        type = 'error';
      } else if (referrerValue && normalizePhone(referrerValue) === ownPhoneValue) {
        referrerErrorField.innerText = this.validateMessages.referrerPhoneSame;
        referrerErrorField.classList.remove('hidden');
        type = 'error';
      } else {
        referrerErrorField.classList.add('hidden');
      }
    }

    const dateOfBirthFields = Array.from(this.querySelectorAll('select[id^="EditAccountDateOfBirth"]'));
    const dateOfBirthFieldsWrapper = this.querySelector('#FormField-editAccountBirthday');
    const errorField = dateOfBirthFieldsWrapper.querySelector('.form-field__text--error');
    const hasSomeEmptyValues = dateOfBirthFields.some(field => !field.value);
    const hasAllEmptyValues = dateOfBirthFields.every(field => !field.value);
    const hasAllFilledValues = dateOfBirthFields.length > 0 && dateOfBirthFields.every(field => field.value);
    if (hasAllEmptyValues) {
      errorField?.classList?.add('hidden');
    } else if (hasSomeEmptyValues) {
      errorField?.classList?.remove('hidden');
      type = 'error';
    } else if (hasAllFilledValues) {
      const birthdayYearField = this.querySelector('#EditAccountDateOfBirthYear');
      const birthdayMonthField = this.querySelector('#EditAccountDateOfBirthMonth');
      const birthdayDayField = this.querySelector('#EditAccountDateOfBirthDay');
      const check = this.handleValidateDate({ year: birthdayYearField.value, month: birthdayMonthField.value, day: birthdayDayField.value });

      if (check) {
        errorField.innerText = "* This is a required field";
        errorField?.classList?.add('hidden');
      } else {
        errorField.innerText = "* Date is not valid.";
        errorField?.classList?.remove('hidden');
        type = 'error';
      }
    }

    const paymentPolicyFieldInput = this.querySelector('#EditAccountSubscribePaymentPolicy');
    if (paymentPolicyFieldInput && !paymentPolicyFieldInput.checked) {
      const paymentPolicyFieldWrapper = paymentPolicyFieldInput.closest('[id^="FormField-"]');
      const paymentPolicyErrorField = paymentPolicyFieldWrapper.querySelector('.form-field__text--error');
      paymentPolicyErrorField?.classList?.remove('hidden');
      type = 'error';
    }

    const securityPolicyFieldInput = this.querySelector('#EditAccountSubscribeSecurityPolicy');
    if (securityPolicyFieldInput && !securityPolicyFieldInput.checked) {
      const securityPolicyFieldWrapper = securityPolicyFieldInput.closest('[id^="FormField-"]');
      const securityPolicyErrorField = securityPolicyFieldWrapper.querySelector('.form-field__text--error');
      securityPolicyErrorField?.classList?.remove('hidden');
      type = 'error';
    }

    return { type }
  }

  handleValidateDate({ year, month, day }) {
    const yearInt = parseInt(year);
    const monthInt = parseInt(month) - 1; // 0-indexed (Jan=0, Feb=1)
    const dayInt = parseInt(day);
    const d = new Date(yearInt, monthInt, dayInt);
    return d.getFullYear() === yearInt &&
      d.getMonth() === monthInt &&
      d.getDate() === dayInt;
  }

  async handleFetchInitData() {
    const phoneField = this.querySelector("#EditAccountPhoneNumber");
    if (!phoneField?.value) return;
    const url = window.middlewareUrls.memberCheck;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          mobileNo: phoneField.value,
          email: this.email?.value,
        })
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const resJson = await response.json();
      const data = resJson.data.data.customerInfo;
      const initData = { ...data, mobileNo: data.mobileNo?.replace(/^0/, window.phonePrefix) };
      delete initData.cstmGradeCD
      delete initData.cstmGradeNM;
      delete initData.empID;
      delete initData.mgm;
      delete initData.etcYN;
      this.handleSetInitData(initData, true)
    } catch (error) {
      console.error(error.message);
    }
  }

  handleSetInitData(data = {}, initLoad = false) {
    this.submitData = data;
    if (initLoad) {
      this.subscribeSMS.checked = data.smsYN === "Y";
      this.querySelector('.loading-mask')?.remove();
      this.querySelector('form').classList.remove('custom-visually-hidden');
      return;
    }

    if (data.sex) {
      this.querySelector(`[name="gender"][value="${data.sex}"]`).setAttribute("checked", "")
    }

    if (data.birthDay) {
      const dayField = this.querySelector('#EditAccountDateOfBirthDay');
      const monthField = this.querySelector('#EditAccountDateOfBirthMonth');
      const yearField = this.querySelector('#EditAccountDateOfBirthYear');
      if (dayField) dayField.value = data.birthDay.slice(6, 8);
      if (monthField) monthField.value = data.birthDay.slice(4, 6);
      if (yearField) yearField.value = data.birthDay.slice(0, 4);
    }

    if (data.firstName) {
      this.querySelector('#EditAccountFirstName').value = data.firstName;
    }

    if (data.lastName) {
      this.querySelector('#EditAccountLastName').value = data.lastName;
    }

    this.subscribeEmail.checked = data.emailYN === "Y";
    this.subscribeSMS.checked = data.smsYN === "Y";

    // must be set at the end whether there is data or not
    this.cstmIntgSeq.value = data.cstmIntgSeq ?? "";
  }

  async handleSubmitForm(data) {
    const loadingBtn = this.querySelector('button[type="button"] .loading__spinner');
    loadingBtn.classList.remove('hidden');
    const url = window.middlewareUrls.memberUpdate
    try {
      const resSubmit = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });

      if (!resSubmit.ok) {
        throw new Error(`Response status: ${resSubmit.status}`);
      }

      const resJson = await resSubmit.json();

      const resData = resJson.data;
      if (resData) {
        window.location.reload();
      }
    } catch (e) {
      console.error(e)
    } finally {
      loadingBtn.classList.add('hidden');
    }
  }
})